import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    canPublishProducts: null,
    displayCurrency: "",
    isBanned: null,
    nextTier: null,
    tier: undefined,
    usage: {
        instances: 0,
        workspaces: 0
    }
};
var currentAccountSlice = createSlice({
    initialState: initialState,
    name: "currentAccount",
    reducers: {
        addInstance: function(state) {
            state.usage.instances = state.usage.instances + 1;
        },
        addWorkspace: function(state) {
            state.usage.workspaces = state.usage.workspaces + 1;
        },
        deleteInstance: function(state) {
            if (state.usage.instances > 0) {
                state.usage.instances = state.usage.instances - 1;
            }
        },
        deleteWorkspace: function(state) {
            if (state.usage.workspaces > 0) {
                state.usage.workspaces = state.usage.workspaces - 1;
            }
        },
        setCurrentAccount: function(state, param) {
            var payload = param.payload;
            payload.tier && (state.tier = payload.tier);
            payload.nextTier && (state.nextTier = payload.nextTier);
            payload.displayCurrency && (state.displayCurrency = payload.displayCurrency);
            var _payload_canPublishProducts;
            state.canPublishProducts = (_payload_canPublishProducts = payload.canPublishProducts) !== null && _payload_canPublishProducts !== void 0 ? _payload_canPublishProducts : null;
            var _payload_isBanned;
            state.isBanned = (_payload_isBanned = payload.isBanned) !== null && _payload_isBanned !== void 0 ? _payload_isBanned : null;
            if (payload.usage) {
                state.usage = payload.usage;
            }
        }
    }
});
var _currentAccountSlice_actions = currentAccountSlice.actions;
export var addInstance = _currentAccountSlice_actions.addInstance, addWorkspace = _currentAccountSlice_actions.addWorkspace, deleteInstance = _currentAccountSlice_actions.deleteInstance, deleteWorkspace = _currentAccountSlice_actions.deleteWorkspace, setCurrentAccount = _currentAccountSlice_actions.setCurrentAccount;
export var currentAccountReducer = currentAccountSlice.reducer;

//# sourceMappingURL=current-account.js.map